import { ReactComponent as BasicIcon } from "assets/icons/basic-plan.svg";
import { ReactComponent as PremiumIcon } from "assets/icons/premium-plan.svg";
import { ReactComponent as EcommerceIcon } from "assets/icons/ecommerce-plan.svg";

const plans = [
  {
    icon: <BasicIcon />,
    description: "Security and updates",
    features: [
      {
        label: "Backups",
        value: "4x",
        hint: "We regularly create backups of your website stored on protected cloud storage (both files and database) in order to keep it safe and easily recoverable at all times.",
      },
      {
        label: "Updates",
        value: "1x",
        hint: "We will have your Content Management System like WordPress and WooCommerce, along with all the plugins, regularly updated to the newest version.",
      },
      {
        label: "Web development",
        value: null,
        hint: "We give you a number of hours per month in our subscriptions to use for web development. Any larger-scale projects that would exceed the hours given to you in the subscriptions are billed on an hourly basis, after our estimation and your acceptance.",
      },
    ],
  },
  {
    icon: <PremiumIcon />,
    description: "When you rarely update content on the website (1–2x/month)",
    features: [
      {
        label: "Backups",
        value: "2x",
        hint: "We regularly create backups of your website stored on protected cloud storage (both files and database) in order to keep it safe and easily recoverable at all times.",
      },
      {
        label: "Updates",
        value: "1x",
        hint: "We will have your Content Management System like WordPress and WooCommerce, along with all the plugins, regularly updated to the newest version.",
      },
      {
        label: "Web development",
        value: "1h",
        hint: "We give you a number of hours per month in our subscriptions to use for web development. Any larger-scale projects that would exceed the hours given to you in the subscriptions are billed on an hourly basis, after our estimation and your acceptance.",
      },
    ],
  },
  {
    icon: <EcommerceIcon />,
    description:
      "When you frequently update content on the website (3x+/month)",
    features: [
      {
        label: "Backups",
        value: "4x",
        hint: "We regularly create backups of your website stored on protected cloud storage (both files and database) in order to keep it safe and easily recoverable at all times.",
      },
      {
        label: "Updates",
        value: "8x",
        hint: "We will have your Content Management System like WordPress and WooCommerce, along with all the plugins, regularly updated to the newest version.",
      },
      {
        label: "Web development",
        value: "3h",
        hint: "We give you a number of hours per month in our subscriptions to use for web development. Any larger-scale projects that would exceed the hours given to you in the subscriptions are billed on an hourly basis, after our estimation and your acceptance.",
      },
    ],
  },
];

export default plans;
